import { render, staticRenderFns } from "./ShareCalendarPopover.vue?vue&type=template&id=0c79c2ca&"
import script from "./ShareCalendarPopover.vue?vue&type=script&lang=js&"
export * from "./ShareCalendarPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports